import type { DeepPartial } from '@luna/utils-ts';

import type { Statements } from '../../types/Statements';

export const statementsHUFeatureConfig: DeepPartial<Statements> = {
    hasPaging: true,
    sendStatementIdAsQueryParam: true,
    showCoreStatements: true,
};
